(() => {
  const loadedStyles = new Map();
  const loadedScripts = new Map();

  function loadStylesheet(url) {
    if (!url) {
      return Promise.resolve();
    }

    if (loadedStyles.has(url)) {
      return loadedStyles.get(url);
    }

    const existing = document.querySelector(`link[href="${url}"]`);
    if (existing) {
      const promise = Promise.resolve();
      loadedStyles.set(url, promise);
      return promise;
    }

    const promise = new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = url;
      link.onload = resolve;
      link.onerror = reject;
      document.head.appendChild(link);
    });

    loadedStyles.set(url, promise);
    return promise;
  }

  function loadScript(url) {
    if (!url) {
      return Promise.resolve();
    }

    if (loadedScripts.has(url)) {
      return loadedScripts.get(url);
    }

    const existing = document.querySelector(`script[src="${url}"]`);
    if (existing) {
      const promise = Promise.resolve();
      loadedScripts.set(url, promise);
      return promise;
    }

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = url;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    loadedScripts.set(url, promise);
    return promise;
  }

  function initPopup(root) {
    const openButton = root.querySelector("[data-feed-popup-open]");
    const popup = root.querySelector(".feed-finder-popup");
    const dialog = root.querySelector(".feed-finder-popup__dialog");
    const closeButtons = root.querySelectorAll("[data-feed-popup-close]");
    let assetsPromise = null;
    let closeTimer = null;
    let lastFocused = null;

    if (!openButton || !popup || !dialog) {
      return;
    }

    function preloadAssets() {
      if (!assetsPromise) {
        assetsPromise = Promise.all([
          loadStylesheet(root.dataset.feedQuizStyle),
          loadScript(root.dataset.feedQuizScript)
        ]);
      }

      return assetsPromise;
    }

    async function openPopup() {
      lastFocused = document.activeElement;
      openButton.setAttribute("aria-busy", "true");
      window.clearTimeout(closeTimer);

      try {
        await preloadAssets();
      } catch (error) {
        console.error(error);
      }

      openButton.removeAttribute("aria-busy");
      popup.hidden = false;
      document.body.classList.add("feed-finder-popup-open");
      requestAnimationFrame(() => {
        popup.classList.add("is-open");
        dialog.focus();
      });
    }

    function closePopup() {
      popup.classList.remove("is-open");
      document.body.classList.remove("feed-finder-popup-open");
      closeTimer = window.setTimeout(() => {
        popup.hidden = true;
        if (lastFocused && typeof lastFocused.focus === "function") {
          lastFocused.focus();
        }
      }, 180);
    }

    openButton.addEventListener("click", openPopup);
    openButton.addEventListener("pointerenter", preloadAssets, { once: true });
    openButton.addEventListener("focus", preloadAssets, { once: true });

    closeButtons.forEach((button) => {
      button.addEventListener("click", closePopup);
    });

    root.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && !popup.hidden) {
        closePopup();
      }
    });
  }

  document.querySelectorAll("[data-feed-finder-popup]").forEach(initPopup);
})();
